// Mock data para a página de accueil - sem conexões de API
export const mockAccueilData = {
  projects: [
    {
      project_id: 119,
      project_name: 'Projet CO05a',
      favorite: true,
    },
    {
      project_id: 1119,
      project_name: 'Projet Galerie Intertube',
      favorite: true,
    },
    {
      project_id: 2,
      project_name: 'Projet Demo',
      favorite: false,
    },
    {
      project_id: 3,
      project_name: 'Projet Estacao Ferroviaria',
      favorite: true,
    },
    {
      project_id: 4,
      project_name: 'Projet Usina Hidroeletrica',
      favorite: true,
    },
    {
      project_id: 5,
      project_name: 'Projet Porto Maritimo',
      favorite: true,
    },
    {
      project_id: 6,
      project_name: 'Projet Aeroporto Terminal Sul',
      favorite: false,
    },
    {
      project_id: 7,
      project_name: 'Projet Fabrica de Texteis',
      favorite: false,
    },
  ],

  views: [
    {
      view_id: 2330,
      view_name: 'Plan site de sécurité CO05a',
      view_title: 'Localisation des capteurs',
      project_id: 119,
      view_projection: 0,
      view_copyright: 'ITM+',
      view_flag_fix_pos: 1,
      view_type: 0,
      is_main_view: 1,
      is_visible: 1,
      is_clustered: 1,
      update_time: null,
      view_bound_coordinates: [
        [0, 0],
        [5398, 11810],
      ],
      view_zoom_levels: [-3, 5],
      center: [48.8566, 2.3522],
      zoom: 12,
    },
    {
      view_id: 2358,
      view_name: 'Plan Galerie Intertube',
      view_title: 'Galerie Intertube',
      project_id: 1119,
      view_projection: 0,
      view_copyright: 'ITM+',
      view_flag_fix_pos: 1,
      view_type: 0,
      is_main_view: 1,
      is_visible: 1,
      is_clustered: 1,
      update_time: null,
      view_bound_coordinates: [
        [0, 0],
        [4678, 6617],
      ],
      view_zoom_levels: [-3, 5],
      center: [48.9, 2.4],
      zoom: 13,
    },
  ],

  graphs: [
    {
      graph_id: 301,
      graph_name: 'Graphe Température CO05a',
      project_id: 119,
      graph_type: 'line',
      created_date: new Date().toISOString(),
    },
    {
      graph_id: 302,
      graph_name: 'Graphe Humidité',
      project_id: 119,
      graph_type: 'bar',
      created_date: new Date().toISOString(),
    },
  ],

  alarms: [
    {
      alarm_id: 1,
      label: 'Température trop élevée CO05a',
      severity: 'critical',
      date: Math.floor(Date.now() / 1000),
      project_id: 119,
      sensor_id: 'TEMP_01',
    },
    {
      alarm_id: 2,
      label: 'Capteur non réactif',
      severity: 'warning',
      date: Math.floor(Date.now() / 1000) - 3600,
      project_id: 119,
      sensor_id: 'HUM_02',
    },
    {
      alarm_id: 3,
      label: 'Batterie faible',
      severity: 'info',
      date: Math.floor(Date.now() / 1000) - 7200,
      project_id: 1119,
      sensor_id: 'BATT_01',
    },
  ],

  reports: [
    {
      rapport_id: 1,
      titre: 'Rapport mensuel CO05a - Février 2026',
      description: 'Analyse complète des données',
      date: Math.floor(Date.now() / 1000),
      project_id: 119,
      status: 'generated',
    },
    {
      rapport_id: 2,
      titre: "Rapport d'incidents",
      description: 'Incidents du mois',
      date: Math.floor(Date.now() / 1000) - 86400,
      project_id: 119,
      status: 'generated',
    },
    {
      rapport_id: 3,
      titre: 'Rapport Galerie Intertube',
      description: 'Données de janvier',
      date: Math.floor(Date.now() / 1000) - 172800,
      project_id: 1119,
      status: 'generated',
    },
  ],

  dashboards: [
    {
      dashboard_id: 201,
      dashboard_name: 'Tableau de bord CO05a',
      project_id: 119,
      created_date: new Date().toISOString(),
    },
    {
      dashboard_id: 202,
      dashboard_name: 'Tableau de bord Galerie',
      project_id: 1119,
      created_date: new Date().toISOString(),
    },
  ],

  summary: {
    alarmes: [
      {
        alarm_id: 1,
        message_alarm: 'Temperatura demasiado elevada CO05a',
        alarm_level: 1,
        alarm_time_firing: Math.floor(Date.now() / 1000),
        project_id: 119,
      },
      {
        alarm_id: 2,
        message_alarm: 'Humidade baixa Galeria Intertube',
        alarm_level: 2,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 3600,
        project_id: 1119,
      },
      {
        alarm_id: 3,
        message_alarm: 'Pressão anormal detectada',
        alarm_level: 1,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 7200,
        project_id: 119,
      },
      {
        alarm_id: 4,
        message_alarm: 'Sensor desconectado CO05a',
        alarm_level: 2,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 10800,
        project_id: 119,
      },
      {
        alarm_id: 5,
        message_alarm: 'Falha de comunicacao',
        alarm_level: 3,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 14400,
        project_id: 1119,
      },
    ],
    rapports: [
      {
        rapport_id: 1,
        titre: 'Rapport mensuel CO05a',
        date: Math.floor(Date.now() / 1000),
        project_id: 119,
      },
      {
        rapport_id: 2,
        titre: 'Rapport qualité air',
        date: Math.floor(Date.now() / 1000) - 86400,
        project_id: 119,
      },
      {
        rapport_id: 3,
        titre: 'Rapport température',
        date: Math.floor(Date.now() / 1000) - 172800,
        project_id: 119,
      },
      {
        rapport_id: 4,
        titre: 'Rapport humidité',
        date: Math.floor(Date.now() / 1000) - 259200,
        project_id: 119,
      },
      {
        rapport_id: 5,
        titre: 'Rapport sécurité',
        date: Math.floor(Date.now() / 1000) - 345600,
        project_id: 119,
      },
      {
        rapport_id: 6,
        titre: 'Rapport Galerie Intertube',
        date: Math.floor(Date.now() / 1000) - 432000,
        project_id: 1119,
      },
    ],
    dashboard: {
      dashboard_id: 201,
      dashboard_name: 'Tableau de bord CO05a',
      project_id: 119,
    },
    graph: {
      graph_id: 301,
      graph_name: 'Graphe Température',
      project_id: 119,
    },
    views: [
      {
        view_id: 2330,
        view_name: 'Plan site de sécurité CO05a',
        view_title: 'Localisation des capteurs',
        project_id: 119,
        view_projection: 0,
        view_copyright: 'ITM+',
        view_flag_fix_pos: 1,
        view_type: 0,
        is_main_view: 1,
        is_visible: 1,
        is_clustered: 1,
        center: [48.8566, 2.3522],
        zoom: 12,
      },
      {
        view_id: 2358,
        view_name: 'Plan Galerie Intertube',
        view_title: 'Galerie Intertube',
        project_id: 1119,
        view_projection: 0,
        view_copyright: 'ITM+',
        view_flag_fix_pos: 1,
        view_type: 0,
        is_main_view: 1,
        is_visible: 1,
        is_clustered: 1,
        center: [48.9, 2.4],
        zoom: 13,
      },
    ],
    view: {
      view_id: 2330,
      view_name: 'Plan site de sécurité CO05a',
      view_title: 'Localisation des capteurs',
      project_id: 119,
      center: [48.8566, 2.3522],
      zoom: 12,
    },
    projects: [
      {
        project_id: 119,
        project_name: 'Projet CO05a',
        favorite: true,
      },
      {
        project_id: 1119,
        project_name: 'Projet Galerie Intertube',
        favorite: true,
      },
    ],
  },
};
